import { Link } from "react-router-dom";
import { Linkedin, ArrowUpRight } from "lucide-react";
import { Reveal } from "../Reveal";

export default function ProfileLinkedin({ profile }) {
  return (
    <section id="linkedin" className="bg-ink-950 text-paper grain relative py-24 md:py-32 overflow-hidden" data-testid="profile-linkedin">
      <div className="absolute -right-24 top-0 w-[500px] h-[500px] rounded-full bg-gold/8 blur-[130px]" />
      <div className="relative z-10 mx-auto max-w-[900px] px-5 md:px-10 text-center">
        {profile.linkedin_url && (
          <Reveal>
            <div className="mx-auto w-14 h-14 rounded-full border border-gold/40 text-gold flex items-center justify-center">
              <Linkedin size={24} />
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-semibold mt-6 tracking-tight">Retrouvez Majdi Zarougui sur LinkedIn</h2>
            <p className="text-paper/60 text-lg mt-5 max-w-2xl mx-auto leading-relaxed">
              Retrouvez mes publications, retours d'expérience et contenus consacrés à l'industrialisation,
              au Lean Manufacturing et à l'Excellence Opérationnelle.
            </p>
            <a href={profile.linkedin_url} target="_blank" rel="noopener noreferrer" data-testid="linkedin-follow-btn"
              className="inline-flex items-center gap-2 mt-9 rounded-full bg-gold text-ink px-8 py-4 label-mono hover:bg-paper transition-colors duration-300">
              Suivre Majdi Zarougui sur LinkedIn <ArrowUpRight size={16} />
            </a>
          </Reveal>
        )}
        <Reveal delay={0.1}>
          <div className={profile.linkedin_url ? "mt-20 pt-12 border-t border-paper/10" : ""}>
            <span className="label-mono text-gold">[ Contact ]</span>
            <h3 className="font-display text-2xl md:text-4xl font-semibold mt-4 tracking-tight">Un projet d'amélioration industrielle ?</h3>
            <p className="text-paper/55 mt-4 max-w-xl mx-auto">Diagnostic, chantier Lean, industrialisation ou formation : échangeons sur votre situation.</p>
            <Link to="/contact" data-testid="profile-contact-cta"
              className="inline-flex items-center gap-2 mt-8 rounded-full border border-paper/25 px-8 py-4 label-mono text-paper hover:border-gold hover:text-gold transition-colors duration-300">
              Discuter de votre projet <ArrowUpRight size={16} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
